import React, { FC, useState } from 'react';
import { MultiValue } from 'react-select';
import SectionTitle from '@src/components/SectionTitle';
import { CompanyTypeType } from '@src/graphql/generated';
import { Option } from '@src/components/Select/interfaces/option.interface';
import { MultiSelectDropdownInput } from '@src/components/Select/MultiSelectDropdownInput';
import { CompanyTypesProps } from './props';
import './styles.scss';

export const CompanyTypes: FC<CompanyTypesProps> = ({ onChange, value, data, isInvalid }) => {
  const typesToOptions = (types: Pick<CompanyTypeType, 'id' | 'name'>[]): Option[] => {
    return types.map(type => {
      return {
        label: type.name,
        value: type.id,
      };
    });
  };

  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(typesToOptions(value || []));

  return (
    <div className="company-types">
      <SectionTitle size="S" title={'Company type'} />

      <MultiSelectDropdownInput
        value={selectedOptions}
        isInvalid={isInvalid}
        onChange={selectedOptions => {
          if (!selectedOptions) {
            return;
          }

          setSelectedOptions(selectedOptions);

          const selectedTypes = data?.filter(type => selectedOptions.some(option => option.value === type.id));

          onChange?.(selectedTypes || []);
        }}
        options={typesToOptions(data || [])}
        placeholder="Please select"
      />
    </div>
  );
};
